export default __webpack_public_path__ + "static/media/english-to-turkish-screenshot-03.f5b05d58.png";